import { render, staticRenderFns } from "./SettingsBusinessDetails.vue?vue&type=template&id=2d90b831&"
import script from "./SettingsBusinessDetails.vue?vue&type=script&lang=js&"
export * from "./SettingsBusinessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports